"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.datesInRange = exports.isDateInRange = void 0;
const lodash_1 = __importDefault(require("lodash"));
/**
 * Evaluates if a date is within a range. Defaults to inclusive of start and end dates.
 *
 * @param inclusive defines if both start and end dates are inclusive, not to be used with startInclusive or endInclusive
 * @param startInclusive defines if start date is inclusive, can be used in tandem with endInclusive
 * @param endInclusive defines if end date is inclusive, can be used in tandem with startInclusive
 */
const isDateInRange = ({ start, end, date, inclusive, startInclusive, endInclusive, }) => {
    const greaterThanStart = date > start;
    const greaterThanAndEqualToStart = date >= start;
    const lessThanEnd = date < end;
    const lessThanAndEqualToEnd = date <= end;
    // if all 3 undefined, default to inclusive
    if (lodash_1.default.isNil(inclusive) && lodash_1.default.isNil(startInclusive) && lodash_1.default.isNil(endInclusive)) {
        // eslint-disable-next-line no-param-reassign
        inclusive = true;
    }
    else if (lodash_1.default.isNil(inclusive)) {
        // if inclusive not defined, then default undfined start and end inclusive to true
        if (lodash_1.default.isNil(startInclusive)) {
            // eslint-disable-next-line no-param-reassign
            startInclusive = true;
        }
        if (lodash_1.default.isNil(endInclusive)) {
            // eslint-disable-next-line no-param-reassign
            endInclusive = true;
        }
    }
    if (inclusive === true) {
        return greaterThanAndEqualToStart && lessThanAndEqualToEnd;
    }
    if (startInclusive && endInclusive) {
        return greaterThanAndEqualToStart && lessThanAndEqualToEnd;
    }
    if (!startInclusive && endInclusive) {
        return greaterThanStart && lessThanAndEqualToEnd;
    }
    if (startInclusive && !endInclusive) {
        return greaterThanAndEqualToStart && lessThanEnd;
    }
    return greaterThanStart && lessThanEnd;
};
exports.isDateInRange = isDateInRange;
/**
 * Returns a filtered list of dates that are within a range. Defaults to inclusive of start and end dates.
 *
 * @param inclusive defines if both start and end dates are inclusive, not to be used with startInclusive or endInclusive
 * @param startInclusive defines if start date is inclusive, can be used in tandem with endInclusive
 * @param endInclusive defines if end date is inclusive, can be used in tandem with startInclusive
 */
const datesInRange = ({ start, end, dates, inclusive, startInclusive, endInclusive, }) => {
    const isDateInRangeEvaluator = (date) => {
        if (lodash_1.default.isBoolean(inclusive)) {
            return (0, exports.isDateInRange)({
                start,
                end,
                date,
                inclusive,
            });
        }
        return (0, exports.isDateInRange)({ start, end, date, startInclusive, endInclusive });
    };
    return dates.filter(isDateInRangeEvaluator);
};
exports.datesInRange = datesInRange;
//# sourceMappingURL=range.js.map